
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/PasswordRecovery.aspx",
      function () {
        return require("private-next-pages/PasswordRecovery.aspx/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/PasswordRecovery.aspx"])
      });
    }
  